const pagination = {
  LIMITS: ["10", "25", "50"],
};

export default pagination;
